module.exports = __webpack_public_path__ + "img/wmpc-logo-r.18d02c7b.png";